/*
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if (summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }
    summary.addEventListener('click', (event) => {
        closeAllCollapsible(event);
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

function closeAllCollapsible(event) {
    document.querySelectorAll(`[id^="Details-"]:not([id^=${event.currentTarget.closest('details').id}])`).forEach((detailsElement) => {
        console.log('detailsElement', detailsElement)
        detailsElement.removeAttribute('open');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    })
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}
*/

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}
customElements.define("deferred-media", DeferredMedia);

if (!Util) function Util() {}

Util.addClass = function (el, className) {
  var classList = className.split(" ");
  el.classList.add(classList[0]);
  if (classList.length > 1) Util.addClass(el, classList.slice(1).join(" "));
};

Util.removeClass = function (el, className) {
  var classList = className.split(" ");
  el.classList.remove(classList[0]);
  if (classList.length > 1) Util.removeClass(el, classList.slice(1).join(" "));
};

Util.addClass = function (el, className) {
  var classList = className.split(" ");
  el.classList.add(classList[0]);
  if (classList.length > 1) Util.addClass(el, classList.slice(1).join(" "));
};

Util.toggleClass = function (el, className, bool) {
  if (bool) Util.addClass(el, className);
  else Util.removeClass(el, className);
};

Util.setAttributes = function (el, attrs) {
  for (var key in attrs) {
    el.setAttribute(key, attrs[key]);
  }
};

Util.hasClass = function (el, className) {
  return el.classList.contains(className);
};

Util.getChildrenByClassName = function (el, className) {
  var children = el.children,
    childrenByClass = [];
  for (var i = 0; i < children.length; i++) {
    if (Util.hasClass(children[i], className))
      childrenByClass.push(children[i]);
  }
  return childrenByClass;
};

Util.getIndexInArray = function (array, el) {
  return Array.prototype.indexOf.call(array, el);
};

class McpAccordion extends HTMLElement {
  constructor() {
    super();

    this.summaries = [...this.querySelectorAll('[id^="Details-"] summary')];

    //console.log('ACCORDION', this)
    this.summaries.forEach((summary) => {
      summary.addEventListener("click", this.handleClick.bind(this));
      summary.parentElement.addEventListener(
        "keyup",
        this.onKeyUpEscape.bind(this)
      );
    });
  }

  connectedCallback() {
    this.initCollapsibles();
  }

  initCollapsibles() {
    this.summaries.forEach((summary) => {
      summary.setAttribute("role", "button");
      summary.setAttribute(
        "aria-expanded",
        summary.parentNode.hasAttribute("open")
      );

      if (summary.nextElementSibling.getAttribute("id")) {
        summary.setAttribute("aria-controls", summary.nextElementSibling.id);
      }
    });
  }

  handleClick(event) {
    this.closeAllCollapsible(event);
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  }

  closeAllCollapsible(event) {
    this.querySelectorAll(
      `[id^="Details-"]:not([id^=${event.currentTarget.closest("details").id}])`
    ).forEach((detailsElement) => {
      detailsElement.removeAttribute("open");
      detailsElement
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
    });
  }

  onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector("summary");
    openDetailsElement.removeAttribute("open");
    summaryElement.setAttribute("aria-expanded", false);
    summaryElement.focus();
  }
}
customElements.define("mcp-accordion", McpAccordion);

function smoothScrollTo(event, offset = 120) {
  const targetId = event.target.getAttribute("href");
  const targetPosition = document.querySelector(targetId).offsetTop + offset;
  const startPosition = window.scrollY;
  const distance = targetPosition - startPosition;

  let start;
  let done = false;
  const duration = 1000;

  window.requestAnimationFrame(animate);

  function animate(timeStamp) {
    if (start === undefined) {
      start = timeStamp;
    }
    const elapsed = timeStamp - start;

    //window.scrollTo(0, distance * (elapsed / duration) + startPosition)
    window.scrollTo(
      0,
      easeInOutCubic(elapsed, startPosition, distance, duration)
    );
    if (elapsed < duration) {
      window.requestAnimationFrame(animate);
    } else {
      const scrollEnd = new CustomEvent("scrollEnd", { detail: event.target });
      dispatchEvent(scrollEnd);
    }
  }
}

function easeInOutCubic(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t * t + b;
  t -= 2;
  return (c / 2) * (t * t * t + 2) + b;
}

class McpSidenav extends HTMLElement {
  constructor() {
    super();

    this.list = this.getElementsByClassName("js-sidenav__list")[0];
    this.anchors = this.list.querySelectorAll('a[href^="#"]');
    this.sections = this.getSections();
    this.scrollingSections = [
      ...document.querySelectorAll(".anchor-content__target"),
    ];
    this.scrollingSectionsHeight = 0;

    this.clickScrolling = false;
    this.intervalID = false;
    this.expandedClass = "dropdown--expanded";

    this.offset = 60;

    this.selectedWrapper = this.querySelector(".selected__wrapper");
    this.selected = this.querySelector(".selected__link");

    //console.log('SIDENAV', this) //element

    // declare Intersection Observer options
    const options = {
      root: null,
      threshold: [0, 0.1],
      rootMargin: "0px 0px -70% 0px",
    };
    // instantiate the observer
    const observer = new IntersectionObserver(
      this.handleCallback.bind(this),
      options
    );
    for (let i = 0; i < this.sections.length; i++) {
      observer.observe(this.sections[i]);
    }

    this.list.addEventListener("click", this.handleClick.bind(this));
    this.selectedWrapper.addEventListener(
      "click",
      this.toggleDropdown.bind(this)
    );
  }

  connectedCallback() {
    this.getScreenWidth();
    window.addEventListener("scroll", this.controlSidenavPosition.bind(this));
    window.addEventListener("resize", this.getScreenWidth.bind(this));
    window.addEventListener(
      "scrollEnd",
      this.handleScrollEnd.bind(this),
      false
    );
  }

  controlSidenavPosition() {
    let sidenavSection = this.getBoundingClientRect();
    let lastSection =
      this.sections[this.sections.length - 1].getBoundingClientRect();
    if (sidenavSection.bottom > lastSection.bottom - 20) {
      document.querySelector(".wwi-page-menu").classList.add("visually-hidden");
    } else {
      document
        .querySelector(".wwi-page-menu")
        .classList.remove("visually-hidden");
    }
  }

  handleScrollEnd(event) {
    //console.log('scrollEnd', event.detail);
    this.resetAnchors(event.detail);
  }

  getScreenWidth() {
    if (window.innerWidth >= 1024) {
      this.isDesktop = true;
      this.offset = 120;
    } else {
      this.offset = 60;
      this.isDesktop = false;
      this.selectedWrapper.classList.add("caret-down");
    }
  }

  toggleDropdown() {
    this.list.classList.toggle(this.expandedClass);
    this.selectedWrapper.classList.toggle("caret-down");
  }

  handleCallback(entries, observer) {
    entries.forEach((entry, index) => {
      if (!this.clickScrolling) {
        //console.log('ENTRY', entry)
        this.getVisibleSection(entry);
      }
    });
  }

  handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    let anchor = event.target.closest('a[href^="#"]');
    if (!anchor) return;
    this.toggleDropdown();
    this.clickScrolling = true;
    smoothScrollTo(event, this.offset);
  }

  getSections() {
    let sections = [];
    // get all sections with anchors
    for (let i = 0; i < this.anchors.length; i++) {
      let section = document.querySelector(
        this.anchors[i].getAttribute("href")
      );
      if (section) sections.push(section);
    }
    return sections;
  }

  getVisibleSection(entry) {
    if (this.intervalID) {
      clearInterval(this.intervalID);
    }
    let self = this;
    this.intervalID = setTimeout(function () {
      let halfWindowHeight = window.innerHeight / 2;
      let index = -1;
      for (let i = 0; i < self.sections.length; i++) {
        let top = self.sections[i].getBoundingClientRect().top;
        if (top < halfWindowHeight) index = i;
      }
      if (index > -1) {
        self.resetAnchors(self.anchors[index]);
      }
      this.intervalID = false;
    }, 100);
  }

  resetAnchors(anchor) {
    if (!anchor) return;
    this.clickScrolling = false;
    for (let i = 0; i < this.anchors.length; i++)
      this.anchors[i].classList.remove("sidenav__link--selected");
    anchor.classList.add("sidenav__link--selected");
    this.selected.innerHTML = anchor.innerHTML;
    this.list.classList.remove(this.expandedClass);
    this.selectedWrapper.classList.add("caret-down");
  }
}
customElements.define("mcp-sidenav", McpSidenav);

class McpSwitcher extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onItemChange.bind(this));

    this.switchItems = [...this.querySelectorAll(".switch__item")];
    //console.log('SWITCHER', this);
  }

  onItemChange(event) {
    this.renderSelectedItem(event.target.value);
  }

  renderSelectedItem(index) {
    this.switchItems.forEach((item) => {
      item.classList.add("switch__item--hidden");
    });
    this.querySelector(
      `.switch__item[data-item="item-${index}"]`
    ).classList.remove("switch__item--hidden");
  }
}
customElements.define("mcp-switcher", McpSwitcher);

class McpPopover extends HTMLElement {
  constructor() {
    super();

    // Get all popover in document
    this.documentDisplays = [...document.querySelectorAll("mcp-popover")];

    this.display = this.querySelector(".popover-display");
    this.trigger = this.querySelector(".popover-trigger");

    this.positionTarget = this.getPositionTarget();

    this.viewportGap =
      parseInt(
        getComputedStyle(this).getPropertyValue("--popover-viewport-gap")
      ) || 20;

    this.triggerHeight = this.trigger.offsetHeight;
    this.popoverVisibleClass = "popover--is-visible";
    this.selectedTriggerClass = "popover-control--active";
  }

  connectedCallback() {
    this.initPopover();
    this.initPopoverEvents();

    document.addEventListener("click", (event) => {
      if (event.target.classList.contains(this.selectedTriggerClass)) return;
      this.hideAllDisplays();
    });
  }

  initPopover() {
    // reset popover position
    this.resetPopoverStyle();
    // init aria-labels
    Util.setAttributes(this.trigger, {
      "aria-expanded": "false",
      "aria-haspopup": "true",
    });
  }

  initPopoverEvents() {
    const self = this;
    this.trigger.addEventListener("click", (event) => {
      event.preventDefault();
      setTimeout(() => {
        // if the popover had been previously opened by another trigger element -> close it first and reopen in the right position
        if (
          this.classList.contains(this.popoverVisibleClass) &&
          this.selectedTrigger != this.trigger
        ) {
          this.togglePopover(false, false); // close menu
        }
        // toggle popover
        this.selectedTrigger = this.trigger;
        self.toggleDisplay(
          !self.display.classList.contains(self.popoverVisibleClass),
          true
        );
      }, "10");
    });
  }

  hideAllDisplays() {
    const self = this;
    this.documentDisplays.forEach((display) => {
      display
        .querySelector(".popover-display")
        .classList.remove(self.popoverVisibleClass);
      display
        .querySelector(".popover-trigger")
        .classList.remove(self.selectedTriggerClass);
      Util.setAttributes(display.querySelector(".popover-trigger"), {
        "aria-expanded": "false",
        "aria-haspopup": "true",
      });
    });
  }

  toggleDisplay(bool) {
    console.log("BOOL", bool);
    this.popoverIsOpen = bool;
    if (bool) {
      this.trigger.setAttribute("aria-expanded", "true");
      this.trigger.classList.add(this.selectedTriggerClass);
      this.display.classList.add(this.popoverVisibleClass);
      // position the popover element
      this.positionPopover();
    } else {
      this.trigger.setAttribute("aria-expanded", "false");
      this.display.classList.remove(this.popoverVisibleClass);
      this.trigger.classList.remove(this.selectedTriggerClass);
    }
  }

  positionPopover() {
    // reset popover position
    this.resetPopoverStyle();

    let displayParentPosition =
      this.closest(".showroom__item").getBoundingClientRect();

    let displayPosition = this.display.positionTarget
      ? this.display.positionTarget.getBoundingClientRect()
      : this.display.getBoundingClientRect();

    //console.log('displayParentPosition', displayParentPosition)
    //console.log('displayPosition', displayPosition)

    if (displayParentPosition.right - displayPosition.right < 0) {
      //console.log('TRIGGER dehors à droite', displayParentPosition.right - displayPosition.right);
      let left =
        displayParentPosition.right - displayPosition.right - this.viewportGap;
      this.display.style.left = `${left}px`;
    }

    if (
      displayParentPosition.bottom - displayPosition.bottom <
      displayPosition.height + this.viewportGap
    ) {
      //console.log('TRIGGER dehors en bas', displayParentPosition.bottom - displayPosition.bottom);
      let bottom = this.triggerHeight + this.viewportGap;
      this.display.style.top = `auto`;
      this.display.style.bottom = `${bottom}px`;
    }
  }

  resetPopoverStyle() {
    // remove popover inline style before appling new style
    this.display.style.top = `${this.triggerHeight}px`;
    this.display.style.left = "0px";
    this.display.style.maxHeight = "";
    this.display.style.bottom = "";
    this.display.style.right = "";
  }

  getPositionTarget() {
    // position tooltip relative to a specified element - if provided
    let positionTargetSelector = this.getAttribute("data-position-target");
    if (!positionTargetSelector) return false;
    let positionTarget = document.querySelector(positionTargetSelector);
    return positionTarget;
  }
}
customElements.define("mcp-popover", McpPopover);

class McpTabsPanel extends HTMLElement {
  constructor() {
    super();

    this.tabList = this.getElementsByClassName("js-tabs__controls")[0];
    this.listItems = this.tabList.getElementsByTagName("li");
    this.triggers = this.tabList.getElementsByTagName("a");
    this.panelsList = this.getElementsByClassName("js-tabs__panels")[0];
    this.panels = Util.getChildrenByClassName(
      this.panelsList,
      "js-tabs__panel"
    );

    this.hideClass = this.getAttribute("data-hide-panel-class")
      ? this.getAttribute("data-hide-panel-class")
      : "hidden";
    this.customShowClass = this.getAttribute("data-show-panel-class")
      ? this.element.getAttribute("data-show-panel-class")
      : false;

    // init tabs
    this.initTab();
  }

  initTab() {
    //set initial aria attributes
    this.tabList.setAttribute("role", "tablist");
    Util.addClass(this, "tabs--no-interaction");

    for (var i = 0; i < this.triggers.length; i++) {
      var bool = i == 0,
        panelId = this.panels[i].getAttribute("id");
      this.listItems[i].setAttribute("role", "presentation");
      Util.setAttributes(this.triggers[i], {
        role: "tab",
        "aria-selected": bool,
        "aria-controls": panelId,
        id: "tab-" + panelId,
      });
      Util.addClass(this.triggers[i], "js-tabs__trigger");
      Util.setAttributes(this.panels[i], {
        role: "tabpanel",
        "aria-labelledby": "tab-" + panelId,
      });
      Util.toggleClass(this.panels[i], this.hideClass, !bool);
      if (bool && this.customShowClass)
        Util.addClass(this.panels[i], this.customShowClass);

      if (!bool) this.triggers[i].setAttribute("tabindex", "-1");
    }
    //listen for Tab events
    this.initTabEvents();
  }

  initTabEvents() {
    let self = this;
    //click on a new tab -> select content
    this.tabList.addEventListener("click", function (event) {
      if (event.target.closest(".js-tabs__trigger"))
        self.triggerTab(event.target.closest(".js-tabs__trigger"), event);
    });
  }

  triggerTab(tabTrigger, event) {
    var self = this;
    event && event.preventDefault();
    var index = Util.getIndexInArray(this.triggers, tabTrigger);
    //no need to do anything if tab was already selected
    if (this.triggers[index].getAttribute("aria-selected") == "true") return;

    Util.removeClass(this, "tabs--no-interaction");

    for (let i = 0; i < this.triggers.length; i++) {
      var bool = i == index;
      Util.toggleClass(this.panels[i], this.hideClass, !bool);
      if (this.customShowClass)
        Util.toggleClass(this.panels[i], this.customShowClass, bool);
      this.triggers[i].setAttribute("aria-selected", bool);
      bool
        ? this.triggers[i].setAttribute("tabindex", "0")
        : this.triggers[i].setAttribute("tabindex", "-1");
    }
  }
}
customElements.define("mcp-tabs-panel", McpTabsPanel);
